import styled from 'styled-components';

const H5 = styled.h5`
  font-size: 22px;
  margin: 0;
`;

export default H5;
